import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import { Card, Table, Descriptions, Divider, Tag } from 'antd';
import html2pdf from 'html2pdf.js';

import api from './../../api.js';
import { useToasts } from "react-toast-notifications";
import { Link, useNavigate } from 'react-router-dom';
import utilis from './../../utilis';
import Dashheader from '../Dashboard/Dashheader/Dashheader.jsx';

const orange = '#fa8c16';

const GetCustomerTracking = () => {
  const { id } = useParams();
  const [customerBookings, setCustomerBookings] = useState([]);
  const contentRef = React.useRef();

  const getCustomertracking = async () => {
    try {
  let response = await api.customerTracking(id);
  const bookings = response?.data?.data || [];
  setCustomerBookings(bookings);
  console.log("Fetched customer Bookings:", bookings);
    } catch (error) {
      console.error("Error fetching customer details:", error);
    }
  };

  useEffect(() => {
    getCustomertracking();
  }, []);

  // Removed unused customerData code from previous version
  const handleDownloadPDF = () => {
    if (contentRef.current) {
      // Use first booking's userDetails for filename
      const user = customerBookings[0]?.userDetails || {};
      html2pdf()
        .set({
          margin: [0.5, 0.2, 0.5, 0.2],
          filename: `${user.name || 'Customer'}_${user.surname || ''}_Tracking.pdf`,
          html2canvas: { scale: 2, scrollX: 0, scrollY: 0, windowWidth: 1200 },
          jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
        })
        .from(contentRef.current)
        .save();
    }
  };

  return (
    <>
      <Dashheader />
      <div style={{ padding: '24px', maxWidth: 1200, margin: '0 auto' }}>
        {customerBookings.length > 0 ? (
          <div ref={contentRef}>
            {/* Show user details from first booking */}
            <Card title="Customer Details" bordered={false} style={{ marginBottom: 24, borderLeft: `6px solid ${orange}` }}>
              <Descriptions column={2}>
                <Descriptions.Item label="Name">{customerBookings[0].userDetails?.name} {customerBookings[0].userDetails?.surname}</Descriptions.Item>
                <Descriptions.Item label="User ID">{customerBookings[0].userDetails?.userId}</Descriptions.Item>
                <Descriptions.Item label="Email">{customerBookings[0].userDetails?.emailId}</Descriptions.Item>
                <Descriptions.Item label="Phone">+{customerBookings[0].userDetails?.countryCode}-{customerBookings[0].userDetails?.phoneNumber}</Descriptions.Item>
                <Descriptions.Item label="Birth Date">{customerBookings[0].userDetails?.birthDate ? new Date(customerBookings[0].userDetails.birthDate).toLocaleDateString() : ''}</Descriptions.Item>
                <Descriptions.Item label="Gender">{customerBookings[0].userDetails?.gender}</Descriptions.Item>
                <Descriptions.Item label="Occupation">{customerBookings[0].userDetails?.occupation}</Descriptions.Item>
                <Descriptions.Item label="Registered On">{customerBookings[0].userDetails?.registeredOn ? new Date(customerBookings[0].userDetails.registeredOn).toLocaleDateString() : ''}</Descriptions.Item>
                <Descriptions.Item label="Address" span={2}>
                  {customerBookings[0].userDetails?.houseNo}, {customerBookings[0].userDetails?.street}, {customerBookings[0].userDetails?.city}, {customerBookings[0].userDetails?.state} - {customerBookings[0].userDetails?.pinCode}
                </Descriptions.Item>
              </Descriptions>
            </Card>

            {customerBookings.map((booking, idx) => {
              // Get active scheme (last one)
              const activeScheme = booking.schemeDetails?.[booking.schemeDetails.length - 1];
              const emiSchedules = activeScheme?.scheme || [];
              // Totals
              const totalDue = emiSchedules.reduce((sum, schedule) => sum + (schedule.amount || 0), 0);
              const totalPaidWithoutGst = emiSchedules.reduce((sum, schedule) => {
                if (schedule.partialPayment && schedule.partialPayment.length > 0) {
                  return sum + schedule.partialPayment.reduce((s, p) => s + (p.withoutGst || 0), 0);
                }
                return sum;
              }, 0);
              const totalPaidWithGst = emiSchedules.reduce((sum, schedule) => {
                if (schedule.partialPayment && schedule.partialPayment.length > 0) {
                  return sum + schedule.partialPayment.reduce((s, p) => s + (p.amount || 0), 0);
                }
                return sum;
              }, 0);
              const outstanding = totalDue - totalPaidWithoutGst;

              // Payment history
              const allPartialPayments = (booking.schemeDetails || []).flatMap(scheme =>
                (scheme.scheme || []).flatMap(schedule =>
                  (schedule.partialPayment || []).map(p => ({
                    ...p,
                    paymentType: 'EMI',
                    scheduleName: schedule.name,
                  }))
                )
              );
              const emiPaymentIds = new Set(allPartialPayments.map(p => p.paymentId));
              const bookingPayments = booking.paymentIds
                ? booking.paymentIds.filter(p => !emiPaymentIds.has(p.paymentId)).map(p => ({
                    ...p,
                    paymentType: 'Booking',
                  }))
                : [];
              const allPayments = [...bookingPayments, ...allPartialPayments];

              return (
                <div key={booking._id} style={{ marginBottom: 32 }}>
                  <Divider orientation="left" style={{ color: orange, borderColor: orange }}>Booking #{idx + 1} - Flat No: {booking.flatNo}</Divider>
                  <Card bordered={false} style={{ marginBottom: 24, borderLeft: `6px solid ${orange}` }}>
                    <Descriptions column={2}>
                      <Descriptions.Item label="Flat No">{booking.flatNo}</Descriptions.Item>
                      <Descriptions.Item label="Block">{booking.block}</Descriptions.Item>
                      <Descriptions.Item label="Tower">{booking.towerName}</Descriptions.Item>
                      <Descriptions.Item label="Floor">{booking.floor}</Descriptions.Item>
                      <Descriptions.Item label="Facing">{booking.facing}</Descriptions.Item>
                      <Descriptions.Item label="Bedrooms">{booking.bedrooms}</Descriptions.Item>
                      <Descriptions.Item label="Unit Type">{booking.unitType}</Descriptions.Item>
                      <Descriptions.Item label="Parking Slot">{booking.parkingSlot}</Descriptions.Item>
                      <Descriptions.Item label="Sq. Feet">{booking.sqFeet}</Descriptions.Item>
                      <Descriptions.Item label="Base Amount">{booking.baseAmount}</Descriptions.Item>
                      <Descriptions.Item label="Total Amount">{booking.totalAmount}</Descriptions.Item>
                      <Descriptions.Item label="Booking No">{booking.bookedNo}</Descriptions.Item>
                      <Descriptions.Item label="Booking Date">{booking.createdOn ? new Date(booking.createdOn).toLocaleDateString() : ''}</Descriptions.Item>
                      <Descriptions.Item label="Status">
                        {booking.isCompleted ? <Tag color="green">Completed</Tag> : <Tag color="orange">Ongoing</Tag>}
                      </Descriptions.Item>
                      <Descriptions.Item label="Download PDF">
                        <a href={booking.url} target="_blank" rel="noopener noreferrer">Download</a>
                      </Descriptions.Item>
                    </Descriptions>
                  </Card>

                  <Divider orientation="left" style={{ color: orange, borderColor: orange }}>Payment Schedules</Divider>
                  <Card bordered={false} style={{ borderLeft: `6px solid ${orange}` }}>
                    <Table
                      dataSource={emiSchedules}
                      rowKey="_id"
                      pagination={false}
                      bordered
                      style={{ borderColor: orange }}
                      columns={[
                        { title: 'Schedule Name', dataIndex: 'name', key: 'name', render: name => name || '—' },
                        { title: 'Percentage', dataIndex: 'percent', key: 'percent', render: percent => `${percent}%` },
                        { title: 'Due Date', dataIndex: 'dueDate', key: 'dueDate', render: d => new Date(d).toLocaleDateString() },
                        { title: 'Amount Due', dataIndex: 'amount', key: 'amount', render: amount => amount?.toLocaleString() || 0 },
                        { title: 'Paid Amount', dataIndex: 'paidAmount', key: 'paidAmount', render: paid => paid?.toLocaleString() || 0 },
                        { title: 'Paid GST Amount', dataIndex: 'gstAmount', key: 'gstAmount', render: gst => gst?.toLocaleString() || 0 },
                        { title: 'Balance', key: 'balance', render: (_, r) => ((r.amount || 0) - (r.withoutGst || 0)).toLocaleString() },
                        { title: 'Status', dataIndex: 'status', key: 'status', render: s => <Tag color={s === 'PAID' ? 'green' : s === 'PARTIALLY PAID' ? 'orange' : 'red'}>{s}</Tag> },
                        { 
                          title: 'Partial Payments', 
                          key: 'partialPayment', 
                          render: (_, r) => r.partialPayment && r.partialPayment.length > 0 
                            ? r.partialPayment.map((p, i) => (
                                <div key={i}>
                                  {p.amount?.toLocaleString()} on {new Date(p.paidOn).toLocaleDateString()}
                                </div>
                              )) 
                            : '—' 
                        },
                        { 
                          title: 'Penalties', 
                          key: 'penalty', 
                          render: (_, r) => r.penalty && r.penalty.length > 0 
                            ? r.penalty.filter(p => p.amount > 0).map((p, i) => (
                                <div key={i}>
                                  {p.amount} ({p.remarks})
                                </div>
                              ))
                            : '—' 
                        },
                      ]}
                    />
                    <div style={{ marginTop: 16 }}>
                      <strong>Total Paid (Without GST):</strong> <span style={{ color: orange }}>{totalPaidWithoutGst.toLocaleString()}</span>
                      <span style={{ marginLeft: 16 }}><strong>Total Paid (With GST):</strong> <span style={{ color: orange }}>{totalPaidWithGst.toLocaleString()}</span></span> <br />
                      <strong>Total Due:</strong> <span style={{ color: orange }}>{totalDue.toLocaleString()}</span> <br />
                      <strong>Outstanding Balance:</strong> <span style={{ color: orange }}>{outstanding.toLocaleString()}</span>
                    </div>
                  </Card>

                  <Divider orientation="left" style={{ color: orange, borderColor: orange }}>Payment History</Divider>
                  <Card bordered={false} style={{ marginBottom: 24, borderLeft: `6px solid ${orange}` }}>
                    {allPayments.length === 0 ? (
                      <div>No payment history found.</div>
                    ) : (
                      <Table
                        dataSource={allPayments}
                        rowKey={r => r.paymentId || r._id || Math.random()}
                        pagination={false}
                        bordered
                        style={{ borderColor: orange }}
                        columns={[
                          { title: 'Type', dataIndex: 'paymentType', key: 'paymentType' },
                          { title: 'Schedule', dataIndex: 'scheduleName', key: 'scheduleName', render: name => name || '—' },
                          { title: 'Payment ID', dataIndex: 'paymentId', key: 'paymentId' },
                          { title: 'Amount (Without GST)', dataIndex: 'withoutGst', key: 'withoutGst', render: amount => amount?.toLocaleString() || '—' },
                          { title: 'GST Amount', dataIndex: 'gstAmount', key: 'gstAmount', render: amount => amount?.toLocaleString() || '—' },
                          { title: 'Total Amount', dataIndex: 'amount', key: 'amount', render: amount => amount?.toLocaleString() || '—' },
                          { title: 'Paid On', dataIndex: 'paidOn', key: 'paidOn', render: d => d ? new Date(d).toLocaleDateString() : '—' },
                          { title: 'Remarks', dataIndex: 'remarks', key: 'remarks', render: r => r || '—' },
                        ]}
                      />
                    )}
                  </Card>
                </div>
              );
            })}
            <button onClick={handleDownloadPDF}>
              Download PDF
            </button>
          </div>
        ) : (
          <div>Loading...</div>
        )}
      </div>
    </>
  );
};

export default GetCustomerTracking;
